// this function should be used for the mobile header to disable scroll when a overlay is open
export const toggleHTMLOverflowHidden = () => {
  document.querySelector('html').classList.toggle('overflow-y-hidden')
}
